import React, { Component } from "react";
import CircularJSON from "circular-json";
import InputLabel from "@material-ui/core/InputLabel";
import Button from "@material-ui/core/Button";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import NuxeoClient from "../../clients/NuxeoClient";
import ArrayUtils from "../../utils/ArrayUtils";
import StringUtils from "../../utils/StringUtils";
import EventUtils from "../../utils/EventUtils";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import Loading from "../../components/loading/Loading";

import AddProductModal from "../ui/AddProductModal";
import Table from "../ui/Table";
import { FavMenu } from "../ui/FavMenu";
import SnackBar from "../ui/SnackBar";
import { JobLoadingModal } from "../ui/Modals";
import Licensee from "../inputs/Licensee";
import Contract from "../inputs/Contract";
import Territories from "../inputs/Territories";
import Property from "../inputs/Property";
import Text from "../inputs/Text";
import AssociatedJobs from "../inputs/AssociatedJobs";

import "../../css/submissionFields.css";
import { GAPageView } from "../..";
import ReactGA from "react-ga";

import { I18nContext } from "../../I18nProvider";

export class PublishingPlanSubmissionFields extends Component {
  static contextType = I18nContext;

  constructor(props) {
    super(props);

    //Define the component state
    this.state = {
      isSubmitting: false,
      requiredFields: [
        "licensee",
        "contract",
        "property",
        "territories",
        "title",
        "modalSubmitData",
      ],
      modalrequiredFields: ["productDetail"],
      modalrequiredFields2: ["productDetail", "pickupFile"],

      licensee: null,
      licenseeID: null,
      licenseePath: null,
      licenseeCode: null,
      contract: "",
      contractID: null,
      territories: [],
      territoriesID: [],
      property: "",
      propertyID: null,
      tierOfDistribution: [],
      retailer: [],
      consumerTarget: [],
      season: [],
      onShelfDate: null,
      inMarketStartDate: null,
      inMarketEndDate: null,
      productTitle: "",
      pubtitle: "",
      additionalNotes: "",
      associatedJobs: [],
      associatedJobsID: [],
      licenseeRef: null,
      retailerSKU: null,
      UPC: null,
      isbn10: null,
      isbn13: null,
      productDetail: null,
      productDetailID: null,
      assetFileName: [],
      assetFileID: null,
      originalAssetsUID: [],
      originalAssetsParentRef: [],
      pickupFile: [],
      pickupFileID: [],
      characters: [],
      charactersID: [],
      coverPrice: "",
      name: [],
      inMarketSeason: null,
      isPickup: false,
      lineSheetRef: "",
      isFavorite: false,
      favoriteName: null,

      //data-fetching state variables
      fetchedLicensees: [],
      fetchedProperty: [],
      fetchedAssetFileCharacters: [],
      fetchedPickupFiles: [],

      //modal variables
      modalOpened: false,
      modalSubmitData: [],
      resetModal: true,
      editModal: false,
      editData: null,
      editIndex: null,

      isJobInfoLoading: false,

      //snackbar
      openSnackMsg: false,
      snackBarMsg: "Sample Msg",
    };
    this.docPrefix = "pub";
    this.docType = "SubmissionPublishing";
    this.document = null;

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitModal = this.handleSubmitModal.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.setJobInfo = this.setJobInfo.bind(this);
  }

  //fetching dropdown data from Nuxeo
  async componentDidMount() {
    await this._createEmptyDoc();
    GAPageView("Publishing Submission Form");
  }

  async _createEmptyDoc() {
    await NuxeoClient.instance()
      .fetchDocument(this.docType)
      .then((response) => {
        this.document = response;
      });
  }

  setJobInfo(jobInfo) {
    this.setState({ isJobInfoLoading: true });
    this.clearValues();

    this.setState({ contractID: jobInfo["submission:contract"] });
    this._getInfoById(jobInfo["submission:contract"]).then((res) =>
      this.setState({ contract: res.title }, () =>
        this._checkFieldChange("contract")
      )
    );

    this.setState({ territoriesID: jobInfo["submission:territories"] });
    jobInfo["submission:territories"].forEach((territory, index) => {
      this._getInfoById(territory).then((response) => {
        let territories = [...this.state.territories];
        territories.push(response.title);
        this.setState({ territories });
      });
    });

    this.setState({ propertyID: jobInfo["submission:property"] });
    this._getInfoById(jobInfo["submission:property"]).then((response) => {
      this.setState({ property: response.title }, () =>
        this._checkFieldChange("property")
      );
    });

    this.setState({ associatedJobsID: jobInfo["submission:associatedJobs"] });
    jobInfo["submission:associatedJobs"].forEach((id) => {
      this._getInfoById(id).then((response) => {
        let associatedJobs = [...this.state.associatedJobs];
        associatedJobs.push(response.title);
        this.setState({ associatedJobs });
      });
    });

    let productsArray = jobInfo[this.docPrefix + "_submission:product"];
    let modalSubmitData = [];
    for (var i = 0; i < productsArray.length; i++) {
      modalSubmitData[i] = this.getModalSubmitData();
    }
    productsArray.forEach((product, index) => {
      if (product[this.docPrefix + "_originalAssets"]) {
        product[this.docPrefix + "_originalAssets"].forEach((asset) => {
          this._getInfoById(asset, index).then((response) => {
            var assetsArray = [
              ...modalSubmitData[response.index].assetFileName,
            ];
            assetsArray.push(response.title);
            modalSubmitData[response.index].assetFileName = assetsArray;
          });
        });
      }

      if (product[this.docPrefix + "_characters"]) {
        product[this.docPrefix + "_characters"].forEach((character) => {
          this._getInfoById(character, index).then((response) => {
            var charactersArray = [
              ...modalSubmitData[response.index].characters,
            ];
            charactersArray.push(response.title);
            modalSubmitData[response.index].characters = charactersArray;
          });
        });
        modalSubmitData[index].charactersID =
          product[this.docPrefix + "_characters"];
      }

      if (product[this.docPrefix + "_pickupFile"]) {
        modalSubmitData[index].pickupFileID =
          product[this.docPrefix + "_pickupFile"];
        product[this.docPrefix + "_pickupFile"].forEach((file) => {
          this._getInfoById(file, index).then((response) => {
            var pickupFiles = [...modalSubmitData[response.index].pickupFile];
            pickupFiles.push(response.title);
            modalSubmitData[response.index].pickupFile = pickupFiles;
          });
        });
      }

      modalSubmitData[index].productDetailID =
        product[this.docPrefix + "_productDetail"];
      this._getInfoById(product[this.docPrefix + "_productDetail"], index).then(
        (response) =>
          (modalSubmitData[response.index].productDetail = response.title)
      );

      modalSubmitData[index].licenseeRef =
        product[this.docPrefix + "_internalRefId"];
      modalSubmitData[index].retailerSKU = product[this.docPrefix + "_sku"];
      modalSubmitData[index].isbn10 = product[this.docPrefix + "_upc"];
      modalSubmitData[index].isbn13 = product[this.docPrefix + "_isbn13"];
      modalSubmitData[index].onShelfDate =
        product[this.docPrefix + "_inMarketDate"];
      modalSubmitData[index].originalAssetsUID = product[
        this.docPrefix + "_originalAssets"
      ]
        ? product[this.docPrefix + "_originalAssets"]
        : [];
      modalSubmitData[index].coverPrice = product[
        this.docPrefix + "_pricePoint"
      ]
        ? product[this.docPrefix + "_pricePoint"]
        : "";
      modalSubmitData[index].isPickup = product[this.docPrefix + "_isPickup"];
    });

    this.setState({
      tierOfDistribution: jobInfo["submission:tierOfDistribution"],
      retailer: jobInfo["submission:retailer"],
      consumerTarget: jobInfo["submission:consumerTarget"],
      onShelfDate: jobInfo["submission:inMarketDate"],
      productTitle: jobInfo["dc:description"],
      lineSheetRef: jobInfo["submission:internalRefId"],
      additionalNotes: jobInfo["submission:notes"],
      season: jobInfo["submission:inMarketSeason"],
      issue: jobInfo["pub_submission:issue"],
      title: jobInfo["pub_submission:title"],
    });

    setTimeout(() => {
      this.setState({
        modalSubmitData,
        isJobInfoLoading: false,
      });
    }, 5000);
  }

  async _getInfoById(id, index = null) {
    var response;

    await NuxeoClient.instance()
      .getJobInfo(id)
      .then((res) => {
        response = res;
      });
    response.index = index;

    return response;
  }

  async _loadPickupFiles(input = "") {
    let licenseeList = "";
    let propsList = "";

    for (let code of this.state.fetchedLicensees) {
      licenseeList +=
        ' OR admin:licenseeCodeGroup = "lic:' +
        code.properties["licensee:licenseeCode"] +
        '"';
    }

    for (let prop of this.state.fetchedProperty) {
      propsList += ' OR public:property = "' + prop.id + '"';
    }
    let exclusivity =
      " AND (admin:wbcpRegionGroup IS NULL) AND (admin:licenseeCodeGroup IS NULL" +
      licenseeList +
      ")";
    let allProperties = " AND (public:property IS NULL" + propsList + ")";
    let styleGuideQuery =
      'file:content/mime-type="application/pdf" AND public:theme != "Style Guide Package" and public:theme != "00. Printable Styleguide" and public:theme != "00. Printable Style Guides" and public:theme != "Brand Assurance Guidelines" and admin:publishYn = 1' +
      exclusivity +
      allProperties;
    await NuxeoClient.instance()
      .fetchPickupFiles(styleGuideQuery, input)
      .then((response) => {
        this.setState({ fetchedPickupFiles: response.entries });
      });
  }

  onCloseModal = () => {
    this.setState({
      modalOpened: false,
      resetModal: true,
      editModal: false,
    });
  };

  //handles when values are picked or typed
  handleChange = (name, value) => {
    this.setState(
      {
        [name]: value,
      },
      () => this._checkFieldChange(name)
    );
  };

  handlePickUps = (values) => {
    if (values === null) {
      this.handleChange("pickupFile", []);
      this.handleChange("pickupFileID", []);
    } else if (values.length > this.state.pickupFile.length) {
      let files = [...this.state.pickupFile];
      files.push(values[values.length - 1].label);
      this.handleChange("pickupFile", files);

      let ids = [...this.state.pickupFileID];
      ids.push(values[values.length - 1].uid);
      this.handleChange("pickupFileID", ids);
    } else {
      const fileTitles = values.map((val) => (val = val.label));
      const deletedFile = this.state.pickupFile.filter(
        (val) => !fileTitles.includes(val)
      );

      let deletedIndex;
      let files = [...this.state.pickupFile];
      this.state.pickupFile.forEach((value, index) => {
        if (value === deletedFile[0]) {
          deletedIndex = index;
          files.splice(index, 1);
        }
      });
      this.handleChange("pickupFile", files);

      let ids = [...this.state.pickupFileID];
      ids.splice(deletedIndex, 1);
      this.handleChange("pickupFileID", ids);
    }
  };

  clearValues() {
    this.setState({
      contract: "",
      territories: [],
      property: "",
      title: "",
      issue: "",
      notes: "",
      lineSheetRef: "",
      associatedJobs: [],
      associatedJobsID: [],
    });
  }

  _checkFieldChange(name) {
    if (name === "licenseeCode") {
      this.clearValues();
    }

    if (name === "contractID") {
      if (!this.state.isJobInfoLoading) {
        this.setState({
          territories: [],
          property: "",
          productDetail: null,
          productDetailID: null,
          originalAssetsUID: [],
          originalAssetsParentRef: [],
          characters: [],
          charactersID: [],
        });
      }
    }

    if (name === "propertyID") {
      this.setState({
        originalAssetsUID: [],
        originalAssetsParentRef: [],
        characters: [],
        charactersID: [],
        fetchedAssetFileCharacters: [],
      });
    }
  }

  getModalSubmitData = () => {
    var data = {
      licenseeRef: this.state.licenseeRef,
      productDetail: this.state.productDetail,
      productDetailID: this.state.productDetailID,
      assetFileName: this.state.assetFileName,
      originalAssetsParentRef: this.state.originalAssetsParentRef,
      originalAssetsUID: this.state.originalAssetsUID,
      retailerSKU: this.state.retailerSKU,
      isbn10: this.state.isbn10,
      isbn13: this.state.isbn13,
      isPickup: this.state.isPickup,
      pickupFile: this.state.pickupFile,
      pickupFileID: this.state.pickupFileID,
      onShelfDate: this.state.onShelfDate,
      characters: this.state.characters,
      charactersID: this.state.charactersID,
      coverPrice: this.state.coverPrice,
    };
    return data;
  };

  handleSubmitModal = (event) => {
    var regex = /^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$/;

    if (this.state.coverPrice !== "" && this.state.pricePointUSD !== "") {
      if (this.state.coverPrice.toString().match(regex) === null) {
        this.setState({
          openSnackMsg: true,
          snackBarMsg: "Cover price should be a numeric value",
        });
        return false;
      }
    }

    let modalSubmitData = [...this.state.modalSubmitData];

    if (this.state.editModal) {
      modalSubmitData = modalSubmitData.filter(
        (data) => data !== this.state.editData
      );
    }

    modalSubmitData.push(this.getModalSubmitData());

    this.setState({
      modalSubmitData,
      modalOpened: false,
      editModal: false,
      resetModal: true,
    });
  };

  handleCancel() {
    window.location.href = "/#!/home";
  }
  //logs all selected data once form is submitted
  async handleSubmit() {
    //submit progress indicator show
    window.scrollTo(0, 0);
    document.querySelector("body").style.overflow = "hidden";
    this.setState({ isSubmitting: true });

    var submitData = {
      licenseeName: this.state.licensee,
      contract: this.state.contract,
      territories: this.state.territories,
      property: this.state.property,
      tierOfDistribution: this.state.tierOfDistribution,
      retailer: this.state.retailer,
      consumerTarget: this.state.consumerTarget,
      issue: this.state.issue,
      season: this.state.season,
      onShelfDate: this.state.onShelfDate
        ? ArrayUtils.convertToISO(this.state.onShelfDate)
        : null,
      productTitle: this.state.title,
      pubtitle: this.state.title,
      additionalNotes: this.state.additionalNotes,
      associatedJobs: this.state.associatedJobs,
      associatedJobsID: this.state.associatedJobsID,
      licenseeRef: this.state.licenseeRef,
      productDetail: this.state.productDetail,
      assetFileName: this.state.assetFileName,
      characters: this.state.characters,
      coverPrice: this.state.coverPrice,
      lineSheetRef: this.state.lineSheetRef,
    };

    let productsArray = [];

    this.state.modalSubmitData.forEach((item) => {
      let files = [];

      let product = {
        property: this.state.propertyID,
        propertyName: submitData.property,
        contractId: this.state.contractID,
        contractProps: this.state.propertyID,
        pub_pricePoint: item.coverPrice,
        pub_isPickup: item.isPickup,
        pub_characters: item.charactersID,
        pub_charactersLabel: item.characters,
        pub_upc: item.isbn10 === "" ? null : item.isbn10,
        pub_isbn13: item.isbn13 === "" ? null : item.isbn13,
        pub_sku: item.retailerSKU === "" ? null : item.retailerSKU,
        pub_inMarketDate: submitData.onShelfDate,
        pub_internalRefId: item.licenseeRef === "" ? null : item.licenseeRef,
        pub_originalAssets: item.originalAssetsUID,
        pub_originalAssetsLabel: item.assetFileName,
        pub_originalAssetsParentRef: item.originalAssetsParentRef,
        pub_pickupFile: item.pickupFileID,
        pub_pickupFileLabel: item.pickupFile,
        // pub_pickupFileParentRef: pickupFilesParentRef,
        pub_productDetail: item.productDetailID,
        pub_productDetailLabel: [item.productDetail],
        pub_files: files,
      };
      productsArray.push(product);
    });

    //update document
    //this.document.properties['dc:description'] = submitData.productTitle;
    this.document.properties["dc:title"] = submitData.contract;
    this.document.properties[this.docPrefix + "_submission:product"] =
      productsArray;
    this.document.properties["pub_submission:issue"] = submitData.issue;
    this.document.properties["pub_submission:title"] = submitData.pubtitle;
    this.document.properties["submission:associatedJobs"] =
      submitData.associatedJobsID;
    this.document.properties["submission:consumerTarget"] =
      submitData.consumerTarget;
    this.document.properties["submission:inMarketSeason"] = null;
    this.document.properties["submission:contract"] = this.state.contractID;
    this.document.properties["submission:inMarketDate"] = null;
    this.document.properties["submission:internalRefId"] =
      submitData.lineSheetRef;
    this.document.properties["submission:licensee"] = this.state.licenseeID;
    this.document.properties["submission:property"] = this.state.propertyID;
    this.document.properties["submission:propertyName"] = submitData.property;
    this.document.properties["submission:retailer"] = submitData.retailer;
    this.document.properties["submission:territories"] =
      this.state.territoriesID;
    this.document.properties["submission:tierOfDistribution"] =
      submitData.tierOfDistribution;
    this.document.properties["submission:notes"] = submitData.additionalNotes;
    this.document.properties["submission:isFavorite"] = this.state.isFavorite;
    this.document.properties["submission:favoriteName"] =
      this.state.favoriteName;

    let products =
      this.document.properties[this.docPrefix + "_submission:product"];
    let productsOld = JSON.parse(JSON.stringify(products));

    this.document.name =
      this.document.name ||
      StringUtils._sanitizeName(this.document.properties["dc:title"]);
    let documentEnrichmentParams = {
      documentProperties: JSON.stringify(this.document.properties),
      docPrefix: this.docPrefix,
      propertyName: this.document.properties["submission:propertyName"],
      parentRef: this.state.licenseeID,
    };
    this.docPath =
      "/default-domain/workspaces/Submission/" + this.state.licensee;
    NuxeoClient.instance()
      .documentEnrichment(documentEnrichmentParams)
      .then((res) => {
        this.document.properties = res;
        this.document = JSON.parse(CircularJSON.stringify(this.document));
        NuxeoClient.instance()
          .submitDocument(this.docPath, this.document)
          .then((responseDoc) => {
            const jobId =
              this.document.properties["submission:workfrontProjectId"];
            ReactGA.event({
              category: "Form",
              action: "Form Submit",
              transport: "beacon",
              label: `Publishing Submitted - ${this.state.property}`,
            });
            window.history.pushState({}, null, `/submit/publishing?${jobId}`);
            EventUtils.raiseEvent("success", { jobId: jobId }, this.props);
          });
      })
      .catch((error) => {
        this.document.properties[this.docPrefix + "_submission:product"] =
          productsOld;
        console.log("Error in DocumentEnrichment parsing: " + error);
        ReactGA.event({
          category: "Form",
          action: "Form Submit Error",
          transport: "beacon",
          label: `Publishing Form Error - ${error}`,
        });
        alert("Failed to submit job.");

        //submit progress indicator show
        this.setState({ isSubmitting: false });
      });
  }

  handleCheckboxChange = (name) => {
    let value = !this.state[name];
    this.setState({
      [name]: value,
    });
  };

  editRow = (index) => {
    var data = this.state.modalSubmitData[index];

    this.setState({
      editData: data,
      editIndex: index,
      licenseeRef: data.licenseeRef,
      productDetail: data.productDetail,
      productDetailID: data.productDetailID,
      assetFileName: data.assetFileName,
      characters: data.characters,
      charactersID: data.charactersID,
      pickupFile: data.pickupFile,
      pickupFileID: data.pickupFileID,
      originalAssetsUID: data.originalAssetsUID,
      originalAssetsParentRef: data.originalAssetsParentRef,
      retailerSKU: data.retailerSKU,
      isbn13: data.isbn13,
      isbn10: data.isbn10,
      isPickup: data.isPickup,
      onShelfDate: data.onShelfDate,
      coverPrice: data.coverPrice,
      modalOpened: true,
      resetModal: false,
      editModal: true,
    });
  };

  deleteRow = (index) => {
    var data = this.state.modalSubmitData[index];
    const modalSubmitData = this.state.modalSubmitData.filter(
      (item) => item.licenseeRef !== data.licenseeRef
    );

    this.setState({
      modalSubmitData: modalSubmitData,
    });
  };

  loadPickups = (input) => {
    setTimeout(() => {
      this._loadPickupFiles(input);
    }, 2000);
  };

  checkRequiredFields = () => {
    for (var item of this.state.requiredFields) {
      if (
        this.state[item] === null ||
        this.state[item] === "" ||
        (typeof this.state[item] === "object" && this.state[item].length === 0)
      ) {
        if (item === "files") {
          this.setState({
            openSnackMsg: true,
            snackBarMsg:
              "Please, use pencil icon to upload your design from the Add product",
          });
        } else if (item === "modalSubmitData") {
          this.setState({
            openSnackMsg: true,
            snackBarMsg: "Add at least one product to proceed",
          });
        } else {
          item = item.replace(/([A-Z])/g, " $1").trim();
          item = item[0].toUpperCase() + item.slice(1);
          this.setState({
            openSnackMsg: true,
            snackBarMsg: `${item} is required to proceed`,
          });
        }
        return false;
      }
    }
  };

  render() {
    const appText = this.context;

    return (
      <div className="marketing-form-container">
        <Fade in={true} timeout={500}>
          <Grid
            container={true}
            direction="column"
            spacing={4}
            alignItems="stretch"
            className="form-wrapper"
          >
            <Grid item={true} xs={12} style={{ paddingBottom: 0 }}>
              <div id="header-with-fav">
                {/* <h5 className="form-heading">Publishing Plan</h5> */}
                <h5 className="form-heading">{appText.T10}</h5>
                <FavMenu
                  setJobInfo={this.setJobInfo}
                  licensee={this.state.licensee}
                  licenseePath={this.state.licenseePath}
                  docType={this.docType}
                  user={this.props.user}
                  handleChange={this.handleChange}
                />
              </div>
            </Grid>

            <JobLoadingModal isJobInfoLoading={this.state.isJobInfoLoading} />

            <Licensee
              handleChange={this.handleChange}
              value={this.state.licensee}
              fetchedData={this.state.fetchedLicensees}
            />

            <Contract
              value={this.state.contract}
              licenseeCode={this.state.licenseeCode}
              handleChange={this.handleChange}
            />

            {this.state.contract ? (
              <Territories
                value={this.state.territories}
                id={this.state.territoriesID}
                contractID={this.state.contractID}
                handleChange={this.handleChange}
              />
            ) : null}

            {this.state.contract ? (
              <Property
                value={this.state.property}
                fetchedData={this.state.fetchedProperty}
                contractID={this.state.contractID}
                handleChange={this.handleChange}
              />
            ) : null}

            <Tooltip
              arrow
              // title="Please enter a title for this publishing submission"
              title={appText.T330}
            >
              <Grid item={true} xs={12}>
                <InputLabel className="field-label field-text" required>
                  {appText.T299}
                </InputLabel>
                <TextField
                  style={{ marginTop: 5, fontSize: 15, height: 30 }}
                  aria-label="minimum height"
                  rows={1}
                  fullWidth={true}
                  value={this.state.title}
                  className="textArea-field"
                  onChange={(event) =>
                    this.handleChange("title", event.target.value)
                  }
                />
              </Grid>
            </Tooltip>

            {/* <Tooltip arrow title="Please enter the Volume"> */}
            <Tooltip arrow title={appText.T331}>
              <Grid item={true} xs={12}>
                <InputLabel className="field-label field-text">
                  {/* Issue / Volume */}
                  {appText.T300}
                </InputLabel>
                <TextField
                  style={{ marginTop: 5, fontSize: 15, height: 30 }}
                  aria-label="minimum height"
                  rows={1}
                  fullWidth={true}
                  className="textArea-field"
                  value={this.state.issue}
                  onChange={(event) =>
                    this.handleChange("issue", event.target.value)
                  }
                />
              </Grid>
            </Tooltip>

            <Text
              // inputName="Notes for BA Representative"
              inputName={appText.T64}
              value={this.state.additionalNotes}
              field="additionalNotes"
              // message={CommonContants.NOTES_MESSAGE}
              message={appText.T125}
              handleChange={this.handleChange}
            />

            <Text
              // inputName="Linesheet Reference #"
              inputName={appText.T63}
              value={this.state.lineSheetRef}
              field="lineSheetRef"
              // message={CommonContants.LS_REF_MESSSAGE}
              message={appText.T124}
              handleChange={this.handleChange}
            />

            <AssociatedJobs
              handleChange={this.handleChange}
              value={this.state.associatedJobs}
              id={this.state.associatedJobsID}
            />

            <Grid item={true} xs={12}>
              <Button
                variant="outlined"
                disabled={this.state.property ? false : true}
                onClick={() => this.handleChange("modalOpened", true)}
                style={{ width: "100%", fontSize: "1rem" }}
              >
                {/* +Add Product */}
                {appText.T76}
              </Button>

              {this.state.modalOpened === true ? (
                <AddProductModal
                  resetData={this.state.resetModal}
                  edit={this.state.editModal}
                  type={"publishing"}
                  data={this.state}
                  handleChange={this.handleChange}
                  handelChangeAutocomplete={this.handleChange}
                  handleMultipleChange={this.handleChange}
                  handleDelete={this.handleDelete}
                  handleCheckboxChange={this.handleCheckboxChange}
                  handleSave={() => null}
                  handleClose={() => null}
                  handleRemoveFile={() => null}
                  onCloseModal={this.onCloseModal}
                  handleSubmitModal={this.handleSubmitModal}
                  handleOpenModal={this.handleOpenModal}
                  handleDateChange={this.handleDateChange}
                  loadPickups={this.loadPickups}
                  handlePickUps={this.handlePickUps}
                />
              ) : (
                <div></div>
              )}
            </Grid>

            <Table
              modalSubmitData={this.state.modalSubmitData}
              type={"publishing"}
              editRow={this.editRow}
              deleteRow={this.deleteRow}
            />

            <Grid item={true} xs={12}>
              {this.state.licensee &&
              this.state.contract &&
              this.state.property &&
              this.state.territories.length > 0 &&
              this.state.title &&
              this.state.modalSubmitData.length > 0 ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    variant="outlined"
                    className="btn"
                    onClick={this.handleCancel}
                    type="submit"
                    value="Cancel"
                  >
                    {/* Cancel */}
                    {appText.T104}
                  </Button>
                  <Button
                    variant="outlined"
                    className="btn"
                    onClick={this.handleSubmit}
                    type="submit"
                    value="Submit"
                  >
                    {/* Submit */}
                    {appText.T113}
                  </Button>{" "}
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    variant="outlined"
                    className="btn"
                    onClick={this.handleCancel}
                    type="submit"
                    value="Cancel"
                  >
                    {/* Cancel */}
                    {appText.T104}
                  </Button>
                  <span
                    onClick={this.checkRequiredFields}
                    style={{
                      display: "inline-block",
                      width: "auto",
                    }}
                  >
                    <Button
                      variant="outlined"
                      className="btn"
                      disabled
                      onClick={this.handleSubmit}
                      type="submit"
                      value="Submit"
                    >
                      {/* Submit */}
                      {appText.T113}
                    </Button>
                  </span>
                </div>
              )}
            </Grid>
            <Loading hidden={!this.state.isSubmitting}></Loading>
            <SnackBar
              isOpen={this.state.openSnackMsg}
              snackBarMsg={this.state.snackBarMsg}
              handleChange={this.handleChange}
            />
          </Grid>
        </Fade>
      </div>
    );
  }
}

export default PublishingPlanSubmissionFields;
